(() => {
    const PAUSE_AT = 1;
    const CENTER_BAND = 0.25;

    const mqDesktopHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 768px)');

    let cards = [];
    let activeIdx = -1;
    let ticking = false;
    let usingHover = mqDesktopHover.matches;

    function iconLoop(icon, on) {
        if (!icon) return;
        icon.setAttribute('trigger', on ? 'loop' : 'hover');
        if (on && typeof icon.play === 'function') icon.play();
        if (!on && typeof icon.stop === 'function') icon.stop();
    }

    function prepVideo(v) {
        if (!v) return;
        v.muted = true;
        v.playsInline = true;
        if (v.preload !== 'auto') v.preload = 'auto';
        try { if (v.readyState < 1) v.load(); } catch { }
    }

    function clearListeners(v) {
        if (!v || !v._handlers) return;
        if (v._handlers.timeupdate) v.removeEventListener('timeupdate', v._handlers.timeupdate);
        if (v._handlers.ended) v.removeEventListener('ended', v._handlers.ended);
        v._handlers = null;
    }

    function playUntil(v, targetSec) {
        if (!v) return;
        clearListeners(v);
        v._handlers = v._handlers || {};
        v._handlers.timeupdate = () => {
            if (v.currentTime >= targetSec) {
                v.pause();
                v.removeEventListener('timeupdate', v._handlers.timeupdate);
                v._handlers.timeupdate = null;
            }
        };
        v.addEventListener('timeupdate', v._handlers.timeupdate);
        v.play().catch(() => { });
    }

    function playToEndHold(v) {
        if (!v) return;
        clearListeners(v);
        v._handlers = v._handlers || {};
        v._handlers.ended = () => {
            v.pause();
            try { v.currentTime = Math.max(v.duration - 0.001, 0); } catch { }
            v.removeEventListener('ended', v._handlers.ended);
            v._handlers.ended = null;
        };
        v.addEventListener('ended', v._handlers.ended);
        v.play().catch(() => { });
    }

    function deactivateActive() {
        if (activeIdx === -1) return;
        const prev = cards[activeIdx];
        prev.el.classList.remove('is-active');
        iconLoop(prev.icon, false);
        if (prev.video) playToEndHold(prev.video);
        activeIdx = -1;
    }

    function activate(idx) {
        if (idx === activeIdx || idx < 0 || idx >= cards.length) return;

        if (activeIdx !== -1) {
            const prev = cards[activeIdx];
            prev.el.classList.remove('is-active');
            iconLoop(prev.icon, false);
            if (prev.video) playToEndHold(prev.video);
        }

        activeIdx = idx;
        const curr = cards[activeIdx];
        curr.el.classList.add('is-active');
        iconLoop(curr.icon, true);

        if (curr.video) {
            prepVideo(curr.video);
            try { curr.video.currentTime = 0; } catch { }
            playUntil(curr.video, PAUSE_AT);
        }
    }

    function pickActiveIndex() {
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const viewportCenter = vh / 2;
        const bandTop = viewportCenter - vh * CENTER_BAND;
        const bandBottom = viewportCenter + vh * CENTER_BAND;

        let bestIdx = -1;
        let bestScore = Infinity;
        for (let i = 0; i < cards.length; i++) {
            const r = cards[i].el.getBoundingClientRect();
            const mid = r.top + r.height / 2;
            const d = Math.abs(mid - viewportCenter);
            const inBand = mid >= bandTop && mid <= bandBottom;
            const score = inBand ? d * 0.5 : d;
            if (score < bestScore) { bestScore = score; bestIdx = i; }
        }
        return bestIdx;
    }

    function onScrollOrResize() {
        if (!usingHover) {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                const idx = pickActiveIndex();
                activate(idx);
                ticking = false;
            });
        }
    }

    function attachHover() {
        usingHover = true;
        window.removeEventListener('scroll', onScrollOrResize);
        window.removeEventListener('resize', onScrollOrResize);

        cards.forEach((c, i) => {
            c._onEnter = () => activate(i);
            c._onLeave = () => { if (activeIdx === i) deactivateActive(); };
            c.el.addEventListener('mouseenter', c._onEnter);
            c.el.addEventListener('focusin', c._onEnter);
            c.el.addEventListener('mouseleave', c._onLeave);
            c.el.addEventListener('focusout', c._onLeave);
        });

        deactivateActive();
    }

    function detachHover() {
        cards.forEach(c => {
            if (c._onEnter) {
                c.el.removeEventListener('mouseenter', c._onEnter);
                c.el.removeEventListener('focusin', c._onEnter);
                c._onEnter = null;
            }
            if (c._onLeave) {
                c.el.removeEventListener('mouseleave', c._onLeave);
                c.el.removeEventListener('focusout', c._onLeave);
                c._onLeave = null;
            }
        });
    }

    function attachScroll() {
        usingHover = false;
        detachHover();
        window.addEventListener('scroll', onScrollOrResize, { passive: true });
        window.addEventListener('resize', onScrollOrResize);
        document.addEventListener('load', onScrollOrResize, true);
        onScrollOrResize();
    }

    function handleModeChange() {
        if (mqDesktopHover.matches) attachHover();
        else attachScroll();
    }

    function init() {
        cards = Array.from(document.querySelectorAll('.pcard')).map(el => {
            const icon = el.querySelector('lord-icon');
            const video = el.querySelector('video');
            if (video) prepVideo(video);
            if (icon && !icon.hasAttribute('trigger')) icon.setAttribute('trigger', 'hover');
            return { el, icon, video };
        });
        if (!cards.length) return;

        handleModeChange();
        if (mqDesktopHover.addEventListener) mqDesktopHover.addEventListener('change', handleModeChange);
        else mqDesktopHover.addListener(handleModeChange);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
